import { useNavigate } from 'react-router'
import { useLocation } from 'react-router-dom'

import { Box, IconButton } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { ADAPTIVE_AUTH_EMAIL, APP_ROUTES } from 'router/constants'
import i18n from 'utils/i18n'

import LogoFrance from './assets/images/logo-fr.svg'
import LogoJapan from './assets/images/logo-ja.svg'
import LogoHongkong from './assets/images/logo-zh-HK.svg'
import LogoTaiwan from './assets/images/logo-zh-TW.svg'
import LogoChina from './assets/images/logo-zh.svg'
import LogoGlobal from './assets/images/logo.svg'
import { boxContentStyle, iconButtonContentStyle, iconButtonStyle, wrapperBoxStyle } from './styled'

export function HeaderWithoutMenu() {
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()

  const { language } = i18n

  let Logo = LogoGlobal

  switch (language) {
    case 'fr-FR':
      Logo = LogoFrance
      break

    case 'ja-JP':
      Logo = LogoJapan
      break

    case 'zh-HK':
      Logo = LogoHongkong
      break

    case 'zh-TW':
      Logo = LogoTaiwan
      break

    case 'zh-CN':
      Logo = LogoChina
      break

    default:
      Logo = LogoGlobal
      break
  }

  const handleLogoButton = () => {
    if (location.pathname !== APP_ROUTES.DASHBOARD.INTRO && location.pathname !== ADAPTIVE_AUTH_EMAIL) {
      navigate(APP_ROUTES.DASHBOARD.HOME)
    }
  }

  return (
    <Box sx={wrapperBoxStyle(theme)}>
      <Box sx={boxContentStyle}>
        <IconButton disableRipple sx={iconButtonStyle} onClick={handleLogoButton} data-testid='IconButtonDF1917EC'>
          <Box component='img' alt='' src={Logo} minWidth='152px' sx={iconButtonContentStyle(theme)} />
        </IconButton>
      </Box>
    </Box>
  )
}
